module.exports = __webpack_public_path__ + "img/local-19.47114c70.jpg";